import React from 'react';

interface Props {
  color?: string;
  fontSize?: number | string;
}

const Grade: React.FC<Props> = ({ color = 'inherit', fontSize = 'inherit' }) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{ fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`, color }}
      viewBox="0 0 24.383 24.879"
    >
      <g id="Group_4547" data-name="Group 4547" transform="translate(0 0.242)">
        <g
          id="Ellipse_39"
          data-name="Ellipse 39"
          transform="translate(0 0.254)"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <circle cx="12.191" cy="12.191" r="12.191" stroke="none" />
          <circle cx="12.191" cy="12.191" r="11.191" fill="none" />
        </g>
        <g id="Group_4546" data-name="Group 4546" transform="translate(4.332 3.223) rotate(-14)">
          <path
            id="Path_5952"
            data-name="Path 5952"
            d="M7.089,9.509h2.55L6.311,0H3.343L0,9.509H2.493l.663-2.147H6.44Zm-3.4-3.833.706-2.291L4.783,1.9h.029L5.23,3.4l.692,2.276Z"
            transform="translate(0 6.04)"
            fill="currentColor"
          />
          <text
            id="_"
            data-name="+"
            transform="translate(6.324 11)"
            fill="currentColor"
            fontSize="12"
            fontFamily="Work Sans"
            fontWeight="700"
          >
            <tspan x="0" y="0">
              +
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
};

export default Grade;
